/**
 * Ejecuta la división.
 * Devuelve el resto
 *
 * @param {float} dividend:
 * @param {float} divisor:
 *
 * @return {float} el resto
 */

import { getMultiplicator } from './getMultiplicator';

export function mod(dividend, divisor) {
  const multiplicator = getMultiplicator([dividend, divisor]);
  const rest = (multiplicator * dividend) % (multiplicator * divisor);
  return rest / multiplicator;
}
